import React from 'react';
import { CheckboxSC } from './checkbox.styled';
import Error from '../error';

type TProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value'> & {
  name?: string;
  value?: boolean;
  error?: string | boolean;
  children?: React.ReactNode;
  className?: string;
};

const Checkbox: React.FC<TProps> = ({
  className,
  children,
  error,
  value,
  size = 'NM',
  ...props
}) => (
  <CheckboxSC className={className ? className : ''} error={Boolean(error)}>
    <label>
      <input type="checkbox" {...props} checked={value} />
      <span className="checkbox">
        <img src={require('../../assets/svg/icon-check-white.svg').default} height="13" alt="" />
      </span>
    </label>
    <div className="checkbox-text-wrapper">
      {children ? <div className="checkbox-text">{children}</div> : null}
      <Error message={error} />
    </div>
  </CheckboxSC>
);

export default Checkbox;
